/** Device Network tab: adapters, DNS, firewall helpers. */

export const NETWORK_ADAPTERS_SLUG = 'network-adapters'
export const WINDOWS_FIREWALL_SLUG = 'windows-firewall'
export const DEFENDER_DNS_SLUG = 'defender-dns'
export const DHCP_DNS_HEALTH_SLUG = 'dhcp-dns-health'

export const HEALTH_STATUS_VARIANT = {
  PASS: 'success',
  WARN: 'warning',
  FAIL: 'destructive',
  INFO: 'secondary',
}

export function healthStatusVariant(status) {
  return HEALTH_STATUS_VARIANT[String(status || '').toUpperCase()] || 'secondary'
}

export const DNS_FIELDS = {
  dns1: 'DNS 1',
  dns2: 'DNS 2',
}

export function adapterTypeLabel(type) {
  switch (String(type || '').toLowerCase()) {
    case 'wired':
      return 'Wired'
    case 'wifi':
      return 'Wi-Fi'
    case 'virtual':
      return 'Virtual'
    case 'other':
      return 'Other'
    default:
      return type || 'Unknown'
  }
}

export function formatIpList(value) {
  if (Array.isArray(value)) {
    const items = value.map((v) => String(v).trim()).filter(Boolean)
    return items.length ? items.join(', ') : '—'
  }
  if (value == null || value === '') return '—'
  return String(value)
}

export function normaliseAgentIpAddresses(raw) {
  if (raw == null) return []
  if (Array.isArray(raw)) {
    return raw
      .map((item) => {
        if (typeof item === 'string') return item.trim()
        if (item && typeof item === 'object') {
          return String(item.ip || item.address || item.IpAddress || item.IPAddress || '').trim()
        }
        return ''
      })
      .filter(Boolean)
  }
  if (typeof raw === 'string') {
    return raw
      .split(/[,;\s]+/)
      .map((s) => s.trim())
      .filter(Boolean)
  }
  if (typeof raw === 'object') {
    return Object.values(raw)
      .map((v) => String(v).trim())
      .filter(Boolean)
  }
  return []
}

export function macAddressesFromHardware(hardware = []) {
  const row = hardware.find(
    (item) =>
      item?.name === 'MAC addresses' ||
      String(item?.category || '').toLowerCase() === 'network',
  )
  const details = row?.details
  if (!details || typeof details !== 'object') return []
  const list = details.mac_addresses
  if (Array.isArray(list)) return list.map((m) => String(m).trim()).filter(Boolean)
  if (typeof list === 'string') return [list.trim()].filter(Boolean)
  return []
}
